module.exports = __webpack_public_path__ + "img/reports_info.99b2b7ab.png";